import React from 'react';
import { Modal, Tab, OverlayTrigger, Container } from 'react-bootstrap';

const ResubmissionModal = ({ show, onHide, submitDeclaration, referenceNo }) => {
  const sendingTo = ['IE Export', 'IE Import'].includes(show) ? 'Thyme-IT' : 'Descartes';

  return (
    <Modal show={show} onHide={onHide} centered animation={false} dialogClassName="modal-50w">
      <Modal.Header style={{ display: 'block' }}>
        <h3>Reference Number: {referenceNo}</h3>
      </Modal.Header>
      <Modal.Body>
        <h3>Resubmit Declaration</h3>
        <p>Transaction: {show}</p>
        <p>
          You're about to resend this submission to <b>{sendingTo}</b>
        </p>
        <p>Please Confirm this action</p>
      </Modal.Body>
      <Modal.Footer
        class="d-flex flex-row py-3 px-3 gap-3 border-top bg-light justify-content-between align-items-center"
        style={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <button
          id="cancel"
          class="blue-button-teams green-btn"
          onClick={onHide}
          style={{
            borderRadius: '10px',
          }}
        >
          Cancel
        </button>
        <button
          id="confirm"
          class="blue-button-teams"
          onClick={() => {
            submitDeclaration();
            onHide();
          }}
          style={{ borderRadius: '10px', width: '180px' }}
        >
          Resend to {sendingTo}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResubmissionModal;
